// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"e4711b82","413":"007080b9","569":"dc40373e","740":"d53e3fbb"}[chunkId] + ".chunk.css";
};